<template>
  <limited-feature-tooltip v-show="planName" :permission="permission" :addon="addon" :hide="hide">
    <p-badge
      :tone="color"
      class="ml-2"
      @click.native="
        $router
          .push({
            name: 'PlanPick',
            query: { selectedPlan: planName.toString().toLowerCase() },
          })
          .catch(() => {})
      "
    >
      {{ planName }}
    </p-badge>
  </limited-feature-tooltip>
</template>

<script>
import LimitedFeatureTooltip from '@/components/core/LimitedFeatureTooltip';
import { mapGetters } from 'vuex';
import PBadge from '@/components/polaris/PBadge';
export default {
  name: 'LimitedFeaturePill',
  components: {
    LimitedFeatureTooltip,
    PBadge,
  },
  props: {
    permission: {
      type: [String, Array],
      default: '',
    },
    color: {
      type: String,
      default: 'info',
    },
    addon: Boolean,
    hide: Boolean,
  },
  computed: {
    ...mapGetters(['getPermissionPlans', 'getAddons']),
    planName: {
      get() {
        return this.addon
          ? this.getAddons(this.permission)[0]
          : this.getPermissionPlans(this.permission)[0];
      },
    },
  },
};
</script>

<style scoped></style>
